import { defineProductDimensions, frRcpwPricingVersionDimension, frRcpwSelectedDimension } from '@orus.eu/dimensions'

import { frRcpwProductVersionDimension } from './fr-rcpw-dimensions.ts'
import { frRcpwQuoteDimension } from './fr-rcpw-quote-dimension.ts'

export * from './fr-rcpw-activity-dimensions.ts'
export * from './fr-rcpw-dimensions.ts'
export * from './fr-rcpw-exclusions.ts'
export * from './fr-rcpw-policy-item-dimension.ts'
export * from './fr-rcpw-quote-dimension.ts'

export const frRcpwDimensionsModule = defineProductDimensions({
  product: 'fr-rcpw',
  family: null,
  selectionDimension: frRcpwSelectedDimension,
  productVersionDimension: frRcpwProductVersionDimension,
  pricingVersionDimension: frRcpwPricingVersionDimension,
  quoteV3Dimension: frRcpwQuoteDimension,
})
